<!--login-column  -->
<div class="login-column">
    <div class="login-column_header">
        <a (click)="onClickNavigation('')"><img src="../../../../assets/images/bim-logo.png" alt="Business in Maharashtra"></a>
        <div class="clearfix"></div>
        <h4>Welcome to Register system.</h4>
    </div>
    <div class="main-register-holder tabs-act">
        <div class="main-register fl-wrap">
            <ul class="tabs-menu fl-wrap no-list-style">
                <li class="current"><a title="Register"><i class="fal fa-user-plus"></i> Register</a></li>
                <li class=""><a routerLink="/login" title="Login" (click)="onClickNavigation('login')"><i
                            class="fal fa-sign-in-alt"></i> Login</a></li>
            </ul>
            <!--tabs -->
            <div class="tabs-container">
                <div class="tab">
                    <!--tab -->
                    <div id="tab-2" class="tab-content first-tab">
                        <div class="custom-form">
                            <div *ngIf="alert" class="mt-4">
                                <div [ngClass]="alert.cssClass">{{alert.message}}</div>
                            </div>
                            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="main-register-form">
                                <label for="email">Email Address <span>*</span></label>
                                <input id="email" name="email" type="text" formControlName="user_name">
                                <div *ngIf="form.get('user_name')?.invalid && (form.get('user_name')?.dirty || form.get('user_name')?.touched)"
                                    class="form-text text-danger text-start">
                                    <div *ngIf="form.get('user_name')?.errors?.['required']">
                                        Please enter email.
                                    </div>
                                    <div *ngIf="form.get('user_name')?.errors?.['pattern']">
                                        Please enter valid email.
                                    </div>
                                </div>
                                <label for="password">Password <span>*</span></label>
                                <div class="input-group mb-3">
                                    <input id="password" [type]="fieldTextType ? 'text' : 'password'" formControlName="password" class="form-control w-75" name="password"
                                    placeholder="Enter your password" />
                                    <button class="btn btn-secondary password-view" type="button" id="password" (click)="toggleFieldTextType()">
                                        <i class="fal fa-eye-slash" [ngClass]="{'fa-eye-slash': !fieldTextType, 'fa-eye': fieldTextType}"></i>
                                    </button>
                                </div>
                                <div *ngIf="form.get('password')?.invalid && (form.get('password')?.dirty || form.get('password')?.touched)"
                                    class="form-text text-danger text-start">
                                    <div *ngIf="form.get('password')?.errors?.['required']">
                                        Please enter password.
                                    </div>
                                    <div *ngIf="form.get('password')?.errors?.['pattern']">
                                        Must contain at least one number and one uppercase and lowercase letter, and
                                        at least 8 or more characters
                                    </div>
                                    <div *ngIf="form.get('password')?.errors?.['forbiddenName']">
                                        Register without a password is forbidden.
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="check-box" style="margin-top: 12px;">
                                    <label for="checkBusiness" class="radio inline">
                                        <input id="checkBusiness" type="radio" formControlName="user_type"
                                            value="business">
                                        <span>Business</span>
                                    </label>&nbsp;
                                    <label for="checkCustomer" class="radio inline">
                                        <input id="checkCustomer" type="radio" formControlName="user_type"
                                            value="customer">
                                        <span>Customer</span>
                                    </label>
                                </div>
                                <div class="filter-tags ft-list">
                                    <input id="check-a2" type="checkbox" formControlName="i_agree_pp">
                                    <label for="check-a2">I agree to the <a routerLinkActive="active" href="privacy-policy" title="Privacy Policy">Privacy Policy</a></label>
                                </div>
                                <div class="clearfix"></div>
                                <div class="filter-tags ft-list">
                                    <input id="check-a" type="checkbox" formControlName="i_agree_tc">
                                    <label for="check-a">I agree to the <a routerLinkActive="active" href="terms-and-conditions" title="Terms and Conditions">Terms and Conditions</a></label>
                                </div>
                                <input type="hidden" formControlName="active_indicator" value="1">
                                <input type="hidden" formControlName="security_question" value="Test"
                                    placeholder="Security question">
                                <input type="hidden" formControlName="security_answer" value="Test"
                                    placeholder="Security answer">
                                <input type="hidden" formControlName="phoneNumber" value="Test"
                                        placeholder="Security question">
                                <div class="clearfix"></div>
                                <button type="submit" [disabled]="form.invalid" class="btn btn-primary mt-2 w-100">
                                    Register <i class="fas fa-caret-right"></i></button>
                            </form>
                        </div>
                        <div class="log-separator fl-wrap"><span>or</span></div>
                        <div class="fl-wrap">
                            <a routerLink="/" class="btn btn-link mt-3" (click)="onClickNavigation('')" title="Back to Home"> Back to Home </a>
                        </div>
                    </div>

                    <!--tab end -->
                </div>
                <!--tabs end -->
            </div>
        </div>
    </div>
</div>
<!--login-column end-->
<!--login-column-bg  -->
<div class="login-column-bg gradient-bg">
    <!--ms-container-->
    <div class="slideshow-container" data-scrollax="properties: { translateY: '300px' }">
        <div class="swiper-container">
            <div class="mySwiper_photo">
                <div class="swiper-wrapper">
                    <!--ms_item-->
                    <div class="swiper-slide">
                        <div class="ms-item_fs fl-wrap full-height">
                            <div class="bg" style="background-image: url('../assets/images/bg/2.jpg');"></div>
                            <div class="overlay op7"></div>
                        </div>
                    </div>
                    <!--ms_item end-->
                    <!--ms_item-->
                    <div class="swiper-slide ">
                        <div class="ms-item_fs fl-wrap full-height">
                            <div class="bg" style="background-image: url('../../assets/images/bg/3.jpg');"></div>
                            <div class="overlay op7"></div>
                        </div>
                    </div>
                    <!--ms_item end-->
                    <!--ms_item-->
                    <div class="swiper-slide">
                        <div class="ms-item_fs fl-wrap full-height">
                            <div class="bg" style="background-image: url('../../assets/images/bg/4.jpg');"></div>
                            <div class="overlay op7"></div>
                        </div>
                    </div>
                    <!--ms_item end-->
                </div>
            </div>
        </div>
    </div>
    <!--ms-container end-->
    <div class="login-promo-container">
        <div class="container">
            <div class="video_section-title fl-wrap">
                <h2>Get ready to start your exciting journey. <br> Our agency will lead you through the amazing digital
                    world</h2>
            </div>
        </div>
    </div>
</div>
<!--login-column-bg end-->